import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTH: CultureInfo = {
  name: 'en-TH',
  displayName: 'English (Thailand)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TH',
  parent: CultureInfoEn
};
